// Native WebSocket client (Cloudflare Workers compatible)
const WS_URL = (process.env.REACT_APP_WS_URL || 'ws://localhost:4000').replace(/^http/, 'ws');

class SmartSocket {
  constructor() {
    this.ws = null;
    this.room = null;
    this.listeners = {};
    this.reconnectDelay = 2000;
    this.reconnectTimer = null;
    this.shouldReconnect = false;
  }

  connect(room) {
    this.room = room;
    this.shouldReconnect = true;
    this._connect();
    return this;
  }

  _connect() {
    if (this.ws && (this.ws.readyState === WebSocket.OPEN || this.ws.readyState === WebSocket.CONNECTING)) return;
    const url = `${WS_URL}/ws?room=${encodeURIComponent(this.room)}`;
    this.ws = new WebSocket(url);
    this.ws.onopen = () => { this.reconnectDelay = 2000; this._emit('connect'); };
    this.ws.onmessage = (event) => {
      try { const { event: e, data } = JSON.parse(event.data); this._emit(e, data); } catch {}
    };
    this.ws.onclose = () => {
      this._emit('disconnect');
      if (this.shouldReconnect) {
        this.reconnectTimer = setTimeout(() => {
          this.reconnectDelay = Math.min(this.reconnectDelay * 1.5, 30000);
          this._connect();
        }, this.reconnectDelay);
      }
    };
    this.ws.onerror = () => this.ws.close();
  }

  on(event, callback) {
    if (!this.listeners[event]) this.listeners[event] = [];
    this.listeners[event].push(callback);
    return this;
  }

  off(event, callback) {
    if (this.listeners[event]) this.listeners[event] = this.listeners[event].filter(cb => cb !== callback);
    return this;
  }

  _emit(event, data) {
    (this.listeners[event] || []).forEach(cb => { try { cb(data); } catch {} });
  }

  disconnect() {
    this.shouldReconnect = false;
    if (this.reconnectTimer) clearTimeout(this.reconnectTimer);
    if (this.ws) this.ws.close();
    this.listeners = {};
  }
}

let instance = null;

export const getSocket = (room) => {
  if (!instance || instance.room !== room) {
    if (instance) {
      // Clean up old listeners and connection when room changes
      instance.disconnect();
      instance = null;
    }
    instance = new SmartSocket();
    instance.connect(room);
  }
  return instance;
};

export const disconnectSocket = () => {
  if (instance) { instance.disconnect(); instance = null; }
};

export default getSocket;
